import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/ChatMarkdown/TableWrapper.tsx
import * as React from "react";
import { useScrollEdges } from "../../../hooks/useScrollEdges.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function TableWrapper({ children, dir }) {
  const wrapperRef = React.useRef(null);
  const containerRef = React.useRef(null);
  useScrollEdges(containerRef, wrapperRef);
  return /* @__PURE__ */ jsxs("div", { className: "buyscout-table-wrapper", dir, ref: wrapperRef, children: [
    /* @__PURE__ */ jsx("div", { className: "buyscout-table-container", ref: containerRef, children: /* @__PURE__ */ jsx("table", { children }) }),
    /* @__PURE__ */ jsx("div", { className: "buyscout-table-shadow-left", "aria-hidden": "true" }),
    /* @__PURE__ */ jsx("div", { className: "buyscout-table-shadow-right", "aria-hidden": "true" })
  ] });
}
export {
  TableWrapper
};
//# sourceMappingURL=TableWrapper.mjs.map